function roleStamp(role) {
  const parsed = Date.parse(role?.shield_updated_at || '');
  return Number.isFinite(parsed) ? parsed : 0;
}

function newestStamp(roles) {
  return roles.reduce((newest, role) => Math.max(newest, roleStamp(role)), 0);
}

// Status payloads embed a copy of the account. A role colour change does not
// touch those posts, so a cached copy can arrive after the fresh profile and
// paint the previous shield. Keep the copy whose role was saved later.
export function chooseFresherRoles(existing, incoming, rolesSpecified) {
  if (!existing || existing.length === 0) return incoming;
  if (!rolesSpecified) return existing;
  // A cached post can embed the account with no roles. That must not clear
  // a badge the profile already loaded.
  if (incoming.length === 0) return existing;
  return newestStamp(incoming) >= newestStamp(existing) ? incoming : existing;
}
